import React, { useCallback } from 'react';
import { GoChevronDown } from 'react-icons/go';
import { Card } from './styles';
import ModuleRow from './ModuleRow';
import TableLoading from '../TableLoading';

const OperationCard = React.memo(({ 
    operation, 
    companyID,
    isSelected,
    onToggle,
    onModuleClick,
    onCompareVersion,
    onDiscussionClick
}) => {
    const handleModuleClick = useCallback((module) => {
        onModuleClick(operation.description, module, companyID, operation.operationID);
    }, [operation.description, operation.operationID, companyID, onModuleClick]);

    const handleCompareVersion = useCallback((module) => (e) => {
        e.stopPropagation();
        onCompareVersion(companyID, operation.reportYearID, operation.operationID, module.moduleID);
    }, [companyID, operation.reportYearID, operation.operationID, onCompareVersion]);

    const handleDiscussionClick = useCallback((module) => (e) => {
        e.stopPropagation();
        onDiscussionClick(companyID, operation.reportYearID, operation.operationID, module.moduleID);
    }, [companyID, operation.reportYearID, operation.operationID, onDiscussionClick]);

    return (
        <Card className="show" item={operation.operationID}>
            <div 
                className={`card-body ${isSelected ? 'collapsed' : ''}`} 
                onClick={onToggle}
            >
                <div className="col-md-3">
                    <GoChevronDown />{operation.description}
                </div>
                <div className="col-md-2"></div>
                <div className="col-md-2"></div>
                <div className="col-md-1 year-version-column">
                    {operation.year}
                </div>
                <div className="col-md-2"></div>
                <div className="col-md-1"></div>
                <div className="col-md-1">
                    {/* <div className={operation.percentage === 0 ? "status pending" : "status complete"}>
                        {`${operation.percentage}%`}
                    </div> */}
                </div>
            </div>
            <div className={`card collapse ${isSelected ? 'show' : ''}`}>
                {operation.modules ? (
                    operation.modules.length > 0 ? (
                        operation.modules.map((module) => (
                            <ModuleRow
                                key={module.moduleID}
                                module={module}
                                onClickModule={() => handleModuleClick(module)}
                                onClickCompareVersion={handleCompareVersion(module)}
                                onClickDiscussion={handleDiscussionClick(module)}
                            />
                        ))
                    ) : (
                        <div className="no-record-found">
                            <div className="col-md-12">No records found</div>
                        </div>
                    )
                ) : (
                    <TableLoading />
                )}
            </div>
        </Card>
    );
});

OperationCard.displayName = 'OperationCard';

export default OperationCard;


